/**
 * Full Bleed Promo.
 */
 (function($) {

    let arriveOptions       = {
        onceOnly: true, // ensure that registered callbacks fire only once
        existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
    };

    let fullBleedPromo     = '.wp-block-cd-full-bleed-promo';
    let promoImg           = '> img';
    let bleedPromoImg      = fullBleedPromo + ` ${promoImg}`;
    let $fullBleedPromo    = $(fullBleedPromo);
    

    function scalePromos() {
        $fullBleedPromo.each(function() {
            let $image          = $(this).find(promoImg);
            scaleImageContainer($(this), $image);
        });
    }

    function parallaxPromos() {
        $fullBleedPromo.each(function() {
            let $image = $(this).find(promoImg);
            if( !$image.hasClass('is-parallax') ) return;
            let containerView = elementInView($(this));
            if( containerView === 'view' ) {
                parallaxImageContainer($(this), $image);
            }
        });
    }

    $(document).arrive(bleedPromoImg, arriveOptions, scalePromos);

    $(window).on('load', function() {
        scalePromos();
        parallaxPromos();
    });

    $(window).on('resize', function() {
        scalePromos();
    });

    $(window).on('scroll', function() {
        parallaxPromos();
    })

})(jQuery);